import { authService } from '../services/authService';
import { getLimitedUserScope } from '../utils/limitedUserAccess';
import { canUserAccessContabilidad } from '../utils/contabilidadAccess';

/**
 * Contexto de visibilidad del manual (alineado al menú lateral y module-settings).
 */
export function buildManualContext(moduleSettings) {
  const user = authService.getCurrentUser();
  const isLimitedUser = user?.role === 'limitado';
  const isAccountant = user?.role === 'contador';
  const moduleAccess = user?.module_access || {};
  const limitedScope = getLimitedUserScope(user);

  const concesionariaConfigModuloCompleto =
    moduleSettings.produccionConcesionariaEnabled &&
    (!moduleSettings.concesionariaVentaOperacionesEnabled ||
      moduleSettings.produccionConcesionariaPlaneamientoEnabled ||
      moduleSettings.concesionariaOperacionesAlmacenEnabled ||
      moduleSettings.concesionariaRecetasEnabled);

  return {
    user,
    isLimitedUser,
    isAccountant,
    moduleAccess,
    limitedScope,
    settings: moduleSettings,
    canSeeMachinery:
      !isAccountant &&
      moduleSettings.machineryEnabled &&
      (!isLimitedUser || moduleAccess.machinery),
    canSeeActivos: !isAccountant && moduleSettings.activosEnabled && !isLimitedUser,
    canSeeVentas:
      !isAccountant &&
      moduleSettings.ventasEnabled &&
      (!isLimitedUser || limitedScope.showVentas),
    canSeeKardexAudit:
      !isAccountant && moduleSettings.kardexAuditModuleEnabled && limitedScope.showAlmacenes,
    canSeeContabilidad: canUserAccessContabilidad(user),
    canSeeProduccionGeneral:
      !isAccountant &&
      moduleSettings.produccionEnabled &&
      (!isLimitedUser ||
        moduleAccess.produccion ||
        moduleAccess.produccion_concesionaria ||
        moduleAccess.restaurantes),
    canSeeProduccionConcesionaria:
      !isAccountant &&
      (moduleSettings.produccionConcesionariaEnabled ||
        moduleSettings.concesionariaVentaOperacionesEnabled) &&
      (!isLimitedUser || moduleAccess.produccion_concesionaria),
    canSeeRestaurantes:
      !isAccountant &&
      moduleSettings.restaurantesEnabled &&
      (!isLimitedUser || moduleAccess.restaurantes),
    concesionariaConfigModuloCompleto,
    isAdmin: user?.role === 'administrador',
  };
}

export function filterManualModules(modules, ctx) {
  return modules
    .map((mod) => {
      if (mod.isVisible && !mod.isVisible(ctx)) return null;
      const sections = (mod.sections || []).filter(
        (sec) => !sec.isVisible || sec.isVisible(ctx),
      );
      if (sections.length === 0) return null;
      return { ...mod, sections };
    })
    .filter(Boolean);
}
